export const orderPathPrefix = process.env.GATSBY_PATH_PREFIX?.includes("order")
